export default "__VITE_ASSET__K71n30Sf__"